import { connect } from 'react-redux';
import { getDeviationPatchedWithStoreState } from '../../../../CollectionPanel/redux/selectors';
import { changeFaveCustom } from '../../../../CollectionPanel/redux/actionCreators';
import { getVisiblePanel } from '../../../../DeviationPage/redux/selectors';
import { togglePanel } from '../../../../DeviationPage/redux/actions';
var mapStateToProps = function (state, _a) {
    var deviation = _a.deviation, actionBarType = _a.actionBarType;
    var patchedDeviation = getDeviationPatchedWithStoreState(state, deviation);
    return {
        deviation: patchedDeviation,
        isCollectionPanelOpen: getVisiblePanel(state, actionBarType) === 'collection',
    };
};
var mapDispatchToProps = {
    onToggleCollectionPanel: togglePanel.bind(null, 'collection'),
    onChangeFave: changeFaveCustom,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=FavouriteButton.container.js.map